<template>
  <fragment>
    <slot />
  </fragment>
</template>


<script>
import { Fragment } from 'vue-fragment';

// @vuese
// Pusty tag bez ograniczeń vue odnośnie tylko jednego elementu dziecko w komponencie
// @group AppLayout
export default {
  name: 'EmptyTag',
  components: { Fragment }
};
</script>